import React from "react";
import { useLang } from "@/contexts/LangContext";
import { LANGS } from "@/lib/i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useLang();
  return (
    <div className="inline-flex items-center gap-1 border border-[#E9ECEF] bg-white" data-testid="language-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}`}
          className={`px-3 py-1.5 text-xs tracking-[0.18em] uppercase transition-colors ${
            lang === l.code ? "bg-[#0A1128] text-white" : "text-[#0A1128] hover:bg-[#F1F3F5]"
          }`}
          aria-pressed={lang === l.code}
        >
          {compact ? l.label : l.label}
        </button>
      ))}
    </div>
  );
}
